/**
 * @generated SignedSource<<e97113e82243ebf41083fc41ce27dc21>>
 * @relayHash 2b953ef5b6b6591ccafcefb8327e8fb6
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2b953ef5b6b6591ccafcefb8327e8fb6

import { ConcreteRequest } from 'relay-runtime';
export type UserGroup = "ADMIN" | "BLOCKED_USER" | "BOTSTACKS_EXPERT" | "BUBBLE_EXPERT" | "BUILDSHIP_EXPERT" | "C4C_REFERRAL_PROGRAM" | "CLIENT_ONBOARDING_COMPLETE" | "CLIENT_REFERRAL_PILOT" | "COMMUNITY_FEED_BANNED_FROM_POSTING" | "COMMUNITY_FEED_CREATOR" | "COMMUNITY_FEED_CURATOR" | "COMMUNITY_FEED_MEMBER" | "COMMUNITY_FEED_VIEWER" | "COMMUNITY_MANAGER" | "CONTRACTOR_ONBOARDING_COMPLETE" | "CONTRACTOR_PROFILE_COMPLETE" | "CONTRA_EXPERT_TEST" | "CONTRA_FOR_COMPANIES_CLIENT" | "CONTRA_PRO_ACCESS_CODE_EVENT" | "CONTRA_PRO_OLD_PRICE_GROUP" | "CONTRA_TEAM_MEMBER" | "CREATOR_PORTFOLIO_EARLY_ACCESS" | "DESCRIPT_EXPERT" | "EXCLUDED_FROM_DISCOVER" | "EXCLUDED_FROM_MATCHING" | "FLAGGED_USER" | "FLAG_FOR_IMPROVEMENT" | "FLUTTERFLOW_EXPERT" | "FRAMER_AD_EXPERIMENT_ANALYTICS_TAB_AUDIENCE" | "FRAMER_AD_EXPERIMENT_EXPERT_PAGE_AUDIENCE" | "FRAMER_AD_EXPERIMENT_INDEPENDENT_HOME_AUDIENCE" | "FRAMER_AD_EXPERIMENT_JOBS_PAGE_AUDIENCE" | "FRAMER_AD_EXPERIMENT_PROJECT_CREATION_AUDIENCE" | "FRAMER_AD_EXPERIMENT_SERVICES_CREATION_AUDIENCE" | "FRAMER_AD_EXPERIMENT_SIDE_NAV_AUDIENCE" | "FRAMER_EXPERT" | "GLORIFY_EXPERT" | "HAS_CUSTOM_EMAIL_DOMAIN" | "HEY_GEN_EXPERT" | "INSTANT_EXPERT" | "INTEGRATION_TEST_USER" | "JITTER_EXPERT" | "JOB_NETWORK_ACCESS_APPROVED" | "KITTL_EXPERT" | "LOTTIEFILES_X_FIGMA_EXPERT" | "LOTTIEFILES_X_FRAMER_EXPERT" | "LOTTIEFILES_X_WEBFLOW_EXPERT" | "LOW_RATED_USER" | "MANUAL_DEMO_USER" | "MANUAL_TEST_USER" | "ORGANIZATION_MEMBER" | "ORGANIZATION_MEMBER_ROLE_ADMIN" | "ORGANIZATION_MEMBER_ROLE_CONTRA_ADMIN" | "PORTFOLIO_DEVELOPER" | "PORTFOLIO_EARLY_ADOPTER" | "QUICK_RESPONDER" | "RELUME_EXPERT" | "REPLO_EXPERT" | "RIVE_EXPERT" | "SOCIAL_FEATURE_ELIGIBLE" | "SPLINE_EXPERT" | "STANDARD_CLIENT" | "TEST_ADMIN" | "TOP_INDEPENDENT_DISCOVERED" | "TOP_INDEPENDENT_OPTED_IN" | "TOP_INDEPENDENT_OPTED_OUT" | "USER_WITH_INQUIRY_AUTO_APPROVAL" | "USER_WITH_INVOICE_AUTO_APPROVAL" | "USER_WITH_JOB_POSTING_AUTO_APPROVAL" | "USER_WITH_PAID_PROJECT_INVITE_AUTO_APPROVAL" | "VISUAL_ELECTRIC_ADS_ANALYTICS_TAB_AUDIENCE" | "VISUAL_ELECTRIC_ADS_EXPERT_PAGE_AUDIENCE" | "VISUAL_ELECTRIC_ADS_INDEPENDENT_HOME_AUDIENCE" | "VISUAL_ELECTRIC_ADS_JOBS_PAGE_AUDIENCE" | "VISUAL_ELECTRIC_ADS_PROJECT_CREATION_AUDIENCE" | "VISUAL_ELECTRIC_ADS_SERVICES_CREATION_AUDIENCE" | "VISUAL_ELECTRIC_ADS_SIDE_NAV_AUDIENCE" | "WEBFLOW_EXPERT" | "WEBSTUDIO_EXPERT" | "WIX_STUDIO_EXPERT" | "WORKSPACE_ADDED_CONTACT" | "%future added value";
export type AdminAddUserToGroupInput = {
  userGroup: UserGroup;
  userId: string;
};
export type ContraProMenuAdminAddUserToGroupMutation$variables = {
  input: AdminAddUserToGroupInput;
};
export type ContraProMenuAdminAddUserToGroupMutation$data = {
  readonly adminAddUserToGroup: {
    readonly adminUserSearchResult: {
      readonly id: string;
      readonly userGroups: ReadonlyArray<UserGroup>;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message: string;
    }> | null;
  };
};
export type ContraProMenuAdminAddUserToGroupMutation = {
  response: ContraProMenuAdminAddUserToGroupMutation$data;
  variables: ContraProMenuAdminAddUserToGroupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "AdminUserSearchResult",
  "kind": "LinkedField",
  "name": "adminUserSearchResult",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userGroups",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = [
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContraProMenuAdminAddUserToGroupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AdminAddUserToGroupPayload",
        "kind": "LinkedField",
        "name": "adminAddUserToGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContraProMenuAdminAddUserToGroupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AdminAddUserToGroupPayload",
        "kind": "LinkedField",
        "name": "adminAddUserToGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "CollaboratorNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "CollaboratorRoleCountInvalidError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "OrganizationNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "ProductizedServiceCollaboratorNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "ReferBasicOpportunityUserNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "SubmitJoinOrganizationRequestError",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "2b953ef5b6b6591ccafcefb8327e8fb6",
    "metadata": {},
    "name": "ContraProMenuAdminAddUserToGroupMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e9aa743360a4fce403985abf8c6c527e";

export default node;
